/*! (c) Andrea Giammarchi - ISC */

const DCL = 'DOMContentLoaded';
const init = new WeakMap;
const queue: any = [];
const isParsed = (el: ParentNode|null) => {
  do {
    if (el?.nextSibling)
      return true;
  } while ((el = el?.parentNode ?? null));
  return false;
};

const upgrade = () => {
  queue.splice(0).forEach((info: any) => {
    if (init.get(info[0]) !== true) {
      init.set(info[0], true);
      info[0][info[1]]();
    }
  });
};

document.addEventListener(DCL, upgrade);
class HTMLParsedElement extends HTMLElement {
  static withParsedCallback(Class: any, name = 'parsed') {
    const {prototype} = Class;
    const {connectedCallback} = prototype;
    const method = name + 'Callback';
    const cleanUp = (el: HTMLElement, observer: MutationObserver, ownerDocument: Document, onDCL: () => void) => {
      observer.disconnect();
      ownerDocument.removeEventListener(DCL, onDCL);
      parsedCallback(el);
    };
    const parsedCallback = (el: HTMLElement) => {
      if (!queue.length)
        requestAnimationFrame(upgrade);
      queue.push([el, method]);
    };
    Object.defineProperties(
      prototype,
      {
        connectedCallback: {
          configurable: true,
          writable: true,
          value() {
            if (connectedCallback)
              // eslint-disable-next-line prefer-rest-params
              connectedCallback.apply(this, arguments);
            if (method in this && !init.has(this)) {
              // eslint-disable-next-line @typescript-eslint/no-this-alias
              const self = this;
              const {ownerDocument} = self;
              init.set(self, false);
              if (ownerDocument.readyState === 'complete' || isParsed(self))
                parsedCallback(self);
              else {
                const onDCL = () => cleanUp(self, observer, ownerDocument, onDCL);
                ownerDocument.addEventListener(DCL, onDCL);
                const observer = new MutationObserver(() => {
                  /* istanbul ignore else */
                  if (isParsed(self))
                    cleanUp(self, observer, ownerDocument, onDCL);
                });
                observer.observe(self.parentNode, {childList: true, subtree: true});
              }
            }
          }
        },
        [name]: {
          configurable: true,
          get() {
            return init.get(this) === true;
          }
        }
      }
    );
    return Class;
  }
}

HTMLParsedElement.withParsedCallback(HTMLParsedElement);
export default HTMLParsedElement;